<template>
  <div>
    <v-card class="progress-container" v-if="initialLoading">
      <v-progress-circular :size="120" color="primary" indeterminate></v-progress-circular>
    </v-card>
    <div v-else>
      <v-layout v-if="!acl.isWorker()" justify-space-between>
        <v-flex xs3>
          <router-link :to="{ name:'form-fill', params: { schemaId: $route.params.schemaId }}" class="dropdown-item">
            <Tooltip v-slot:default="{on}" :text="$t('button_descriptions.form.new')">
              <v-btn v-on="on">
                <v-icon block color="green darken-2" fab small style="color: #efefef">add</v-icon>
              </v-btn>
            </Tooltip>
          </router-link>
        </v-flex>
        <v-flex xs3 v-if="state == states.COMPLETED">
          <FormButtons :by-user="byUser" :doc-available="docAvailable" @byUser="(byUser = !byUser) & queryForms()"
                       @confirmAll="confirmAll()" @print="printAll()"
                       @printAllCsv="printAllCsv()"></FormButtons>
        </v-flex>
      </v-layout>

      <FilterView v-if="!acl.isWorker() || Settings.allowFilteringForWorkers()" ref="filtrComp"
                  v-on:change-condition="updateConditions($event)">
        <template>
          <v-layout v-if="!acl.isWorker()" style="margin-bottom: 0rem">
            <v-flex sm3 xs5>
              <v-menu v-model="menuFrom" :close-on-content-click="false" :nudge-right="40" full-width
                      lazy min-width="290px"
                      offset-y transition="scale-transition">
                <template v-slot:activator="{ on }">
                  <v-text-field v-model="dateFrom" :label="`${$t('form.search.from')}`" clearable prepend-icon="event"
                                readonly v-on="on"></v-text-field>
                </template>
                <v-date-picker v-model="dateFrom" @input="menuFrom = false"></v-date-picker>
              </v-menu>
            </v-flex>

            <v-flex sm3 xs5>
              <v-menu v-model="menuTo" :close-on-content-click="false" :nudge-right="40" full-width lazy
                      min-width="290px"
                      offset-y transition="scale-transition">
                <template v-slot:activator="{ on }">
                  <v-text-field v-model="dateTo" :label="`${$t('form.search.to')}`" clearable
                                prepend-icon="event" readonly style="margin-left:2rem;" v-on="on"></v-text-field>
                </template>
                <v-date-picker v-model="dateTo" @input="menuTo = false"></v-date-picker>
              </v-menu>
            </v-flex>
          </v-layout>
        </template>
      </FilterView>

      <v-layout v-if="!acl.isWorker() || Settings.allowFilteringForWorkers()" justify-space-between
                style="margin-top: 3rem">
        <v-flex xs3>
          <v-select item-text="name" item-value="value" :items="states.states" @change="queryForms" :label="`${$t('schema.list.forms')}`" v-model="state"></v-select>
        </v-flex>

        <v-flex xs5>
        </v-flex>
        <v-flex sm2 xs2>
          <v-select v-model="template" :items="templates" :label="`${$t('form.template')}`" :menu-props="{ maxHeight: '400' }"
                    item-text="name" return-object></v-select>
        </v-flex>

        <v-flex xs2>
          <v-select v-model="format" :items="['PDF', 'DOCX']" :label="`${$t('form.print-format')}`"
                    :menu-props="{ maxHeight: '400' }"></v-select>
        </v-flex>

        <v-spacer></v-spacer>
        <Tooltip v-slot:default="{on}" :text="$t('button_descriptions.form.edit_in_table')">
          <v-btn :color="editable ? 'green lighten-2' : ''" icon small style="display: block" @click="editable=!editable"
                 v-on="on">
            <v-icon>edit</v-icon>
          </v-btn>
        </Tooltip>
      </v-layout>

      <v-data-table id="formTable" :headers="headers" :items="records" :loading="updateLoading"
                    :no-data-text="tableTranslations.noDataText" :no-results-text="tableTranslations.noResultsText"
                    :rows-per-page-text="tableTranslations.rowsPerPageText"
                    :rows-per-page-items="pagination.rowsPerPageItems" :pagination.sync="pagination" :total-items="totalAmount" class="elevation-1">
        <template slot="headers" slot-scope="props">
          <tr>
            <th style="width: 40px">
              <span class="span-blcok"></span>
            </th>
            <th v-if="Settings.isDefaultNavigationOnLeftSide()" class="narrow-header text-overflow">
              <span class="span-blcok"> Akcje </span>
            </th>
            <th style="width: 40px">
              <span class="span-blcok"> ID </span>
            </th>
            <th v-for="(header,index) in props.headers" :key="header.text+'_'+index" :style="headerWidthStyle"
                class="text-overflow">
              <span class="span-blcok"> {{ header.text }} </span>
              <v-tooltip top v-if="hasDescription(header.value)">
                <template v-slot:activator="{ on :  on }">
                  <v-icon style="margin: -1px 5px;" class="center" color="blue darken-3" small v-on="on">info</v-icon>
                </template>
                <span>{{ formField(header.value).description }}</span>
              </v-tooltip>
            </th>

            <th v-if="!Settings.isDefaultNavigationOnLeftSide()" class="narrow-header text-overflow">
              <span class="span-blcok"> Akcje </span>
            </th>
          </tr>
        </template>
        <template v-if="showSummary" slot="footer">
          <tr class="text-xs-center">
            <td v-for="(sum,key) in summaryNumericFields" :key="key" class="text-overflow text-xs-center" style="background-color:#e6ffe6;text-align: center;vertical-align: middle;">
              <span class="text-xs-center span-blcok" style="margin-top:30px"> {{ sum.value }} </span>

            </td>
          </tr>
        </template>
        <template slot="items" slot-scope="props">
          <tr :class="unconfirmedClass(props)" :style="getRowStyle(props)"
              @dblclick="confirmForm(props.item)">
            <td>
              <v-checkbox v-model="selected[props.item.id]" style="margin-left: 1rem; margin-top: 1.5rem"></v-checkbox>
            </td>
            <td v-if="Settings.isDefaultNavigationOnLeftSide()" class="text-xs-center">
              <NavigationButtons :doc-available="docAvailable" :is-confirmed="isConfirmed(props)" :props="props"
                                 @deleteForm="deleteForm" @toFile="toFile"></NavigationButtons>
            </td>

            <td v-for="(header, index) in formHeaders" :key="index"
                :class="{ 'unvalidate': !isValidate(props.item, header.value) }" class="text-overflow" style="overflow: hidden">

              <table-view v-if="header.type === fieldType.TABLE" :context="createContext(props.item)"
                          :form_id="props.item.id"
                          :rows_amount="props.item[header.value].data" :table="formField(header.value)"
                          @loading="updateLoading = $event"/>

              <div v-else-if="header.type === fieldType.PERMAMENT">{{ props.item[header.value] }}</div>

              <div v-else-if="header.type === fieldType.PHOTO || header.type === fieldType.SIGNATURE"
                   style="overflow-x: hidden;">
                <ImageField v-if="props.item[header.value].data != null && props.item[header.value].data.length >10 "
                            :data="props.item[header.value].data" :field="getSchemaField(header.value)"></ImageField>
              </div>

              <div v-else-if='header.type === fieldType.ARCHIVE'>
                <Archive v-if="props.item[header.value].data != null " :edit="editable" :archive="props.item[header.value].data" />
                <div v-else>Brak</div>
              </div>


              <div v-else-if="header.type === fieldType.RELATED " style="overflow-x: hidden;">
                <Related :code="props.item[header.value].data"
                         :editable="editable" :field="getSchemaField(header.value)"
                         v-on:updateField="updateField(props.item.id, props.item[header.value], header, $event)"/>
              </div>

              <div v-else-if='header.type === fieldType.DEPEND '>
                <Depend :code="props.item[header.value].data" :field="getSchemaField(header.value)" />
              </div>

              <div v-else-if="header.type === fieldType.CONFIRMATION">
                <v-tooltip v-if="isConfirmed(props.item)" top>
                  <template v-slot:activator="{ on }">
                  <span v-on="on">
                    <v-icon class="light-green--text">check_circle_outline</v-icon> {{ props.item[header.value].confirmed_by }}
                  </span>
                  </template>
                  <span>{{ props.item[header.value].confirmed_at }}</span>
                </v-tooltip>
                <v-icon v-else @click="confirmForm(props.item)" class="red--text pointer">highlight_off</v-icon>
              </div>

              <div v-else-if='header.type === fieldType.CHECKBOX'>
                <Checkbox :context="createContext(props.item)" :formData="props.item" :editable="editable" :field=getSchemaField(header.value) :valueField="props.item[header.value].data"
                          v-on:updateField="updateField(props.item.id, props.item[header.value], header, $event)" :validation="props.item[header.value].validation" />
              </div>

              <div v-else-if='header.type === fieldType.RADIO'>
                <Radio :context="createContext(props.item)" :formData="props.item" :editable="editable" :field=getSchemaField(header.value) :valueField="props.item[header.value].data"
                       v-on:updateField="updateField(props.item.id, props.item[header.value], header, $event)" :validation="props.item[header.value].validation" />
              </div>

              <div v-else-if='header.type === fieldType.STORAGE'>
                {{ props.item[header.value].data ?  `${props.item[header.value].data.name} - ${props.item[header.value].data.amount}` : "" }}
              </div>

              <div v-else-if='header.type === fieldType.GEOLOCATION '>
                <Geolocation :location="props.item[header.value].data" :field="getSchemaField(header.value)" />
              </div>

              <div v-else-if='header.type === fieldType.DATE '>
                <Date :context="createContext(props.item)" :formData="props.item" :editable="editable" :field=getSchemaField(header.value) :valueField="props.item[header.value].data"
                      v-on:updateField="updateField(props.item.id, props.item[header.value], header, $event)" :validation="props.item[header.value].validation"></Date>
              </div>

              <div v-else style="overflow-x: hidden;">
                <CustomField :context="createContext(props.item)" :formData="props.item" :editable="editable" :field=getSchemaField(header.value) :valueField="props.item[header.value].data"
                             v-on:updateField="updateField(props.item.id, props.item[header.value], header, $event)" :validation="props.item[header.value].validation">
                </CustomField>
              </div>
            </td>
            <td class="text-xs-center">
              <NavigationButtons v-if="!Settings.isDefaultNavigationOnLeftSide()" :doc-available="docAvailable"
                                 :is-confirmed="isConfirmed(props.item)" :props="props"
                                 @deleteForm="deleteForm" @toFile="toFile"></NavigationButtons>
            </td>
          </tr>
        </template>
      </v-data-table>
      <div>
        <v-layout row wrap>
          <v-flex xs9>
            <span style="cursor:pointer; color:#3f3fff; font-weight: 500" @click="selectAll">Zaznacz wszystko </span>
          </v-flex>
          <v-flex v-if="$store.state.forms.schema.fields.find(f=> f.type == FieldType.SIGNATURE)" xs3>
            <MultiSignDialog :records="records" :schema="$store.state.forms.schema" :selected="selected"
                             @refresh="queryForms()">
              <template v-slot:activator="{on}">
                <div>
                  <span style="cursor:pointer; color:#3f3fff; font-weight: 500;float:right" v-on="on">Podpisz</span>
                </div>
              </template>
            </MultiSignDialog>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <State :id="0" :state="1" direction="right" @stateChanged="updateSelectedState($event)"/>
          <FormColor @updated="updateColor($event)"></FormColor>
        </v-layout>
      </div>
    </div>
    <FormStats :schema="$store.state.forms.schema" class="marrgin-stats"></FormStats>
  </div>
</template>

<script>
import Messenger from "@/plugins/Messenger"
import ObjectHelper from "@/helpers/ObjectHelper"
import http from '@/plugins/http'
import Csv from '@/plugins/printer/Csv'
import fieldType from '@/enums/fieldType'
import states from '@/enums/states'
import TableView from './view/TableView'
import FormStats from "../stats/FormStats"
import FilterView from './view/FilterView'
import CustomField from './view/CustomField'
import Checkbox from './view/Checkbox'
import Radio from './view/Radio'
import Archive from "./view/Archive"
import Related from "./view/Related"
import Depend from "./view/Depend"
import State from "./State"
import FormAdapter from '@/plugins/FormAdapter'
import SummaryCalculator from '@/plugins/SummaryCalculator'
import Context from '@/plugins/Context'
import Upload from './Upload'
import schemaType from "@/enums/schemaType"
import Cookies from "js-cookie"
import Acl from "@/plugins/Acl"
import Geolocation from "./view/Geolocation.vue"
import Date from "./view/Date.vue"
import ImageField from "./view/ImageField.vue"
import {accessControl} from "../../router/rules"
import FormSettings from "./FormSettings.vue"
import FormButtons from "@/components/form/FormButtons.vue"
import FormColor from "@/components/form/FormColor.vue"
import Settings from "@/plugins/Settings"
import MultiSignDialog from './MultiSignDialog.vue'
import FieldType from "../../enums/fieldType"
import NavigationButtons from "./view/NavigationButtons.vue"
import Tooltip from "../common/Tooltip.vue"

export default {
  components: {
    Tooltip,
    NavigationButtons,
    FormColor,
    Geolocation,
    FormStats,
    TableView,
    FilterView,
    CustomField,
    Archive,
    Related,
    Depend,
    State,
    Checkbox,
    Radio,
    Upload,
    ImageField,
    Date,
    FormSettings,
    FormButtons,
    MultiSignDialog
  },
  data() {
    return {
      selected: {},
      headerWidth: 150,
      acl: new Acl(),
      showSummary: false,
      editable: false,
      byUser: false,
      searchPhrase: "",
      dateFrom: "",
      dateTo: "",
      state: 1,
      Settings,
      menuFrom: false,
      menuTo: false,
      initialLoading: true,
      updateLoading: false,
      templates: [],
      template: null,
      format: 'PDF',
      fieldsCondition: {},
      summaryFields: {},
      states: states,
      Context,
      schemaType
    }
  },
  computed: {
    FieldType() {
      return FieldType
    },
    headerWidthStyle() {
      return `width:${this.$store.state.formViewOptions.columnWidth}px;color:rgba(0,0,0,0.54)`
    },
    summaryNumericFields() {
      return this.summaryCalculator.getSummary(this.records)
    },
    docAvailable() {
      return this.template && this.template.hasOwnProperty('id') !== undefined && this.template.id > 0
    },
    tableTranslations() {
      return this.$store.getters.tableTranslations
    },
    fields() {
      return this.$store.state.forms.schema.fields
    },
    formHeaders() {
      let adapter = new FormAdapter(this.$store.state.forms.schema);
      return adapter.getHeaders()
        .filter(header => !this.$store.state.formViewOptions.hiddenFields.includes(String(header.value)))
    },
    headers() {
      return this.formHeaders.slice(1) //delete id header, ii is added manualy
    },
    totalAmount() {
      return this.$store.state.forms.amount
    },
    records() {
      let showFullName = Cookies.get('fullnameautor') == 'true'
      let adapter = new FormAdapter(this.$store.state.forms.schema, showFullName);
      adapter.schema = this.$store.state.forms.schema
      adapter.loadForms(this.$store.state.forms.results)
      return adapter.getRecords();
    },
    fieldType() {
      return fieldType
    },
    confirmation() {
      let firstRecord = this.records.find(() => true)
      if (firstRecord) {
        return firstRecord.hasOwnProperty('confirmation')
      }
      return false
    },
    pagination: {
      get: function() {
        return this.$store.state.formPagination
      },
      set: function(value) {
        this.$store.commit('setFormPagination', value)
      }
    },
    itemTrigger() {
      return [this.pagination, this.dateFrom, this.dateTo]
    }
  },
  watch: {
    updateLoading: function () {
      this.peformTheadColor()
    },
    '$store.getters.darkTheme': function () {
      this.peformTheadColor()
    },
    itemTrigger() {
      if (!this.initialLoading) {
        this.updateLoading = true
        this.queryForms()
          .then(() => {
            this.updateLoading = false
          })
      }
    }
  },
  created() {
    this.$store.commit('setDefaultFormPagination')
    this.initialLoading = true
    this.queryForms()
    this.$store.dispatch('loadRelatedSchemas')
    this.$store.dispatch('loadAgencies')
    this.$store.dispatch('initFormViewOptions', this.$route.params.schemaId)

    if (!accessControl.isAllowed("viewTemplates")) {
      return
    }

    Promise.all([
      http.get('templates/' + this.$route.params.schemaId),
    ]).then(([templates]) => {
      this.templates = templates.data
      if (typeof this.templates[0] !== 'undefined') {
        this.template = this.templates[0]
      }
      this.canShowSummary()
    }).catch(() => {

    })
  },
  methods: {
    unconfirmedClass(props) {
      let prop = Settings.getUnconfirmedClass()
      let obj = {}
      obj[prop] = !this.isConfirmed(props.item)
      return obj
    },
    updateColor({color, alpha}) {
      let ids = this.getSelectedIds()
      if (ids == undefined || ids.length == 0) {
        return
      }

      if (color.length > 1 && Number(alpha) > 0 && Number(alpha) < 100) {
        color = color + String(alpha)
      }

      this.$http.post(`form/${this.$route.params.schemaId}/update-colors`, {color, form_ids: ids})
          .then(({data}) => {
            let idsUpdated = ObjectHelper.getObjectKeysIfValueIsTrue(data)
            if (idsUpdated.length == 0) {
              return Messenger.emitError("Nie można zaktualizować koloru")
            }
            if (idsUpdated.length != ids.length) {
              Messenger.emitError("Nie można zaktualizować wszystkich formularzy")
            }

            if (idsUpdated.length == ids.length) {
              Messenger.emitSuccess("Zaktualizowano formularze")
            }

            return this.queryForms()
          })
    },
    updateSelectedState(state) {
      let ids = this.getSelectedIds()

      if (ids == undefined || ids.length == 0) {
        return
      }
      this.$http.post(`form/${this.$route.params.schemaId}/update-states`, {state: state, form_ids: ids})
          .then(({data}) => {
            let idsUpdated = ObjectHelper.getObjectKeysIfValueIsTrue(data)
            if (idsUpdated.length == 0) {
              return Messenger.emitError("Nie można zaktualizować stanu")
            }
            if (idsUpdated.length != ids.length) {
              Messenger.emitError("Nie można zaktualizować wszystkich formularzy")
            }

            if (idsUpdated.length == ids.length) {
              Messenger.emitSuccess("Zaktualizowano formularze")
            }

            return this.queryForms()
          })
    },
    getSelectedIds() {
      let ids = ObjectHelper.getObjectKeysIfValueIsTrue(this.selected)
      if (ids.length == 0) {
        return Messenger.emitError("Najpierw wybierz formularze")
      }
      return ids
    },
    peformTheadColor() {
      let form = document.querySelector('#formTable')
      if (form) {
        let thead = form.getElementsByTagName('thead').item(0)
        thead.style = this.$store.getters.darkTheme ? 'background-color: rgb(60, 60, 60)' : 'background-color: white'
      }
    },
    getRowStyle(props) {
      if (props.item.color) {
        return 'color:black;background-color:' + props.item.color
      }

      if (!this.$store.getters.darkTheme) {
        if (props.index % 2 == 0) {
          return 'color:black;background-color:white'
        }
        return 'color:black;background-color:#ebebeb'
      }

      if (props.index % 2 == 0) {
        return 'color:black;background-color:#515151'
      }

      return 'color:black;background-color:rgb(98, 98, 98)'
    },
    updateConditions(conditions) {
      this.fieldsCondition = conditions
      this.queryForms()
    },
    selectAll() {
      let check = true
      if (ObjectHelper.getObjectKeysIfValueIsTrue(this.selected).length > 0) {//== this.records.length){
        check = false
      }

      this.records.forEach(el => {
        this.selected[el.id] = check
      })

      this.$forceUpdate()
    },
    isValidate(result, order) {
      if (result[order] != undefined && result[order].validation != undefined && order >= 1)
        return result[order].validation.pass

      return true;
    },
    updateField(idForm, field, header, value) {
      let schemaField = this.getSchemaField(header.value)
      let idSchema = this.$route.params.schemaId
      let payload = {
        idForm,
        idSchema,
        schemaField,
        value
      }

      this.$store.dispatch("updateFieldValue", payload)
        .then(() => {
          this.$store.commit('confirmRecord', {confirmed_at: false, confirmed_by: false, id: idForm})
          this.$store.commit('setSnack', {
            message: this.$t('form.update.success-message'),
            color: 'success'
          })
        }).catch(() => {
          this.$store.commit('setSnack', {
            message: this.$t('form.update.error-message'),
            color: 'danger'
          })
        })
    },
    createContext(records) {
      return Context.createFullFormContext(this.fields, records)
    },
    getSchemaField(order) {
      return this.$store.state.forms.schema.fields.find(field => field.order == order)
    },
    deleteForm(id, index) {
      this.$confirm(this.$t('form.delete.confirmation'))
        .then(res => {
          if (res) {
            this.updateLoading = true
            this.$store.dispatch('deleteForm', {
              schema_id: this.$route.params.schemaId,
              form_id: id,
              index
            })
              .then(() => {
                this.updateLoading = false
                this.$store.commit('setSnack', {
                  message: this.$t('form.delete.success-message'),
                  color: 'success'
                })
              })
              .catch(() => {
                this.updateLoading = false
                this.$store.commit('setSnack', {
                  message: this.$t('form.delete.error-message'),
                  color: 'danger'
                })
              })
          }
        })
    },
    confirmForm(row) {
      if (!this.isConfirmed(row)) {
        this.$confirm(this.$t('form.confirm.confirmation', {
          created_by: row.created_by,
          created_at: row.created_at
        }))
          .then(res => {
            if (res) {

              this.$store.dispatch('confirmForm', {
                schema_id: this.$route.params.schemaId,
                form_id: row.id
              })
                .then(() => {
                  this.updateLoading = false
                  this.$store.commit('setSnack', {
                    message: this.$t('form.confirm.success-message'),
                    color: 'success'
                  })
                  this.queryForms()
                }).catch(() => {
                  this.updateLoading = false
                  this.$store.commit('setSnack', {
                    message: this.$t('form.confirm.error-message'),
                    color: 'danger'
                  })
                })
            }
          })
      }
    },
    confirmAll() {
      http.post('form/confirm/all', {
        schema_id: this.$route.params.schemaId
      }).then(() => {
        this.$store.commit('setSnack', {
          message: this.$t('form.confirm.success-message'),
          color: 'success'
        })
        this.queryForms()
      }).catch(() => {
        this.$store.commit('setSnack', {
          message: this.$t('form.confirm.error-message'),
          color: 'danger'
        })
      })
    },
    isConfirmed(record) {
      if (this.confirmation) {
        return record.confirmation && record.confirmation.hasOwnProperty('confirmed_by') && record.confirmation.confirmed_by !== null
      }
      return true
    },
    toFile(form) {
      http({
        url: '/form/' + form.id + '/print/' + this.template.id + '/' + this.format.toLowerCase(),
        method: 'GET',
        responseType: 'blob'
      })
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', this.template.name + ' - ' + form.created_at + ', ' + form.created_by + '.' + this.format.toLowerCase())
          document.body.appendChild(link)
          link.click()
        });
    },
    getQueryParams(){
      let params = {}
      if (this.dateFrom) {
        params.from =  this.dateFrom
      }
      if (this.dateTo) {
        params.to = this.dateTo
      }

      return Object.assign(params, this.fieldsCondition)
    },
    buildSort() {
      let sort = this.$store.state.formViewOptions.sort
      if (!sort) {
        return
      }

      let res = []
      sort.map((el) => {
        res.push((el.sortType == "desc" ? "-" : "") + String(el.sortField))
      })

      return res

    },
    printAll() {
      let url = '/form/print/all/' + this.template.id + '/' + this.format.toLowerCase() + '?'

      let params = this.getQueryParams()

      params.page = this.pagination.page
      params.pageSize = this.pagination.rowsPerPage

      http({
        url: url,
        method: 'GET',
        responseType: 'blob',
        params: {...params}
      })
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', this.template.name + ' - records' + '.zip')
          document.body.appendChild(link)
          link.click()
        });
    },
    printAllCsv() {
      let params = this.getQueryParams()

      params.page = this.pagination.page
      params.pageSize = this.pagination.rowsPerPage

      http({
        method: 'GET',
        url: 'forms/' + this.$route.params.schemaId + "/full/1",
        params: {...params}
      }).then((result) => {
        let csv = new Csv(this.$store.state.forms.schema)
        csv.printHeaders().loadFormRecods(result.data).save()
      })
    },
    canShowSummary() {
      // tymczasowo wyl. przeniesc to do innego komponentu i dodac do opcji czy ma byc pokazywane
      this.$store.state.forms.schema.fields.forEach((field) => {
        if (field.type == "numberXXX") {
          this.summaryCalculator = new SummaryCalculator(this.$store.state.forms.schema)
          this.showSummary = true
          return
        }
      })
    },
    queryForms() {
      this.selected = {}
      return this.$store.dispatch('loadForms', {
        schema_id: this.$route.params.schemaId,
        pagination: this.pagination,
        state: this.state,
        by_user: this.byUser,
        condition: Object.assign({
          from: this.dateFrom,
          to: this.dateTo,
          sort: this.buildSort()
        }, this.fieldsCondition)
      }).then(() =>{
        this.initialLoading = false})
    },
    formField(order) {
      return this.$store.getters.formField(order)
    },
    hasDescription(filedOrder) {
      let field = this.formField(filedOrder)

      if (field != undefined && field.description != null && field.description.length > 0)
        return true
    },
    openImage(base64, type) {
      let win = window.open("")
      win.document.write('<img  src=\'data:' + type + ";base64," + encodeURI(base64) + "'></img>");
    }
  }
}
</script>

<style>
.unconfirmed {
  background: repeating-linear-gradient(45deg,
  rgba(0, 0, 0, 0.1),
  rgba(0, 0, 0, 0.1) 10px,
  rgba(0, 0, 0, 0.15) 10px,
  rgba(0, 0, 0, 0.15) 20px);
}

.unconfirmedGentler {
  background: repeating-linear-gradient(45deg,
  rgba(0, 0, 0, 0.01),
  rgba(0, 0, 0, 0.02) 10px,
  rgba(0, 0, 0, 0.03) 10px,
  rgba(0, 0, 0, 0.04) 20px);
}
.unvalidate {
  background-color: #ff4d4d !important;
}

.incorrect {
  text-decoration: underline red;
}

.progress-container {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 300px;
}

.imageField {
  height: 100px;
}

.text-overflow {
  text-align: center;
  word-wrap: break-word;
  align: center;
  vertical-align: middle;
}

.center {
  margin: 0 auto;
}

.span-blcok {
  display: inline-block;
  height: 50px;
  white-space: normal;
}

.header {
  width: 200px
}

.narrow-header {
  width: 220px;
}

.marrgin-stats {
  margin-top: 20px;
}

.active{

}

#formTable > div > table > thead {
  position:sticky;
  top: 0px;
  z-index:6;
}

.v-table__overflow {
  overflow-y: scroll !important;
  max-height: 70vh;
}

th > span {
  line-break: anywhere;
  font-size: 10px;
}

table.v-table thead td:not(:nth-child(1)),
table.v-table tbody td:not(:nth-child(1)),
table.v-table thead th:not(:nth-child(1)),
table.v-table tbody th:not(:nth-child(1)),
table.v-table thead td:first-child,
table.v-table tbody td:first-child, table.v-table thead th:first-child, table.v-table tbody th:first-child {
  padding: 0 4px;

}
</style>
